export const colors = {
  gray: {
    8: "#22272D", // gray 8
    7: "#3B454F", // gray 7 
    30: "#5A646E", // gray 6
    20: "#CCD1D6",
    10: "#F2F5F8",
  },
  white: {
    0: "#FFFFFF",
  },
  yellow: {
    50: "#FFAE00",
  },
  red: {
    50: "#FF3541",
  },
}

export const reduce = 1.55
